/**
 * Module dependencies.
 */

import { FavoriteProps } from 'src/types/my-products';
import {
  QueryObserverBaseResult,
  QueryObserverOptions,
  useQuery
} from 'react-query';
import { Token } from 'src/core/utils/requests';
import { fetchFavoriteExists } from './fetch-favorite-exists';
import { useMemo } from 'react';

/**
 * `Result` type.
 */

type Result = QueryObserverBaseResult<FavoriteProps, unknown>;

/**
 * `Options` type.
 */

type Options = QueryObserverOptions<FavoriteProps> & {
  favorableId: string;
  token: Token;
};

/**
 * Action type.
 */

export const actionType = (favorableId: string) => {
  return `favorite-exists-${favorableId}`;
};

/**
 * `useFavoriteExists` hook.
 */

function useFavoriteExists(options?: Options): Result {
  const { favorableId, token, ...rest } = options;
  const variables = useMemo(
    () => ({ favorableId, token }),
    [favorableId, token]
  );

  const result = useQuery(
    [actionType(favorableId), variables],
    () => {
      return fetchFavoriteExists(variables);
    },
    rest
  );

  return result;
}

/**
 * Export `useFavoriteExists` hook.
 */

export default useFavoriteExists;
